import { useLayoutEffect, useRef } from "react";

/*
  Created in order to fire off a callback, `onVisible` when an element goes from
  display: none to display: <something>. It uses the element's height as the determination
  for it's visibility. When `display: none` is set, the element's height is 0.
*/
function useDetectVisibility(onVisible) {
  const elementRef = useRef(null);
  const previousHeightRef = useRef(0);

  useLayoutEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    // Initialize the previous height
    previousHeightRef.current = element.getBoundingClientRect().height;

    const observer = new ResizeObserver((entries) => {
      // Convert entries to an array and iterate using forEach
      Array.from(entries).forEach((entry) => {
        const currentHeight = entry.contentRect.height;
        if (previousHeightRef.current === 0 && currentHeight > 0) {
          onVisible(currentHeight);
        }
        previousHeightRef.current = currentHeight;
      });
    });

    observer.observe(element);
    return () => observer.disconnect();
  }, [onVisible]);

  return elementRef;
}

export default useDetectVisibility;
